import { RequestRemovalModal } from 'components/company-profile/components/RequestRemovalModal';
import { ChoosePartnerModal } from 'components/company-profile-edit/components/ChoosePartnerModal';
import { CreatePartnerModal } from 'components/company-profile-edit/components/CreatePartnerModal';

const companyProfileModals = {
    companyProfileChoosePartner: ChoosePartnerModal,
    companyProfileCreatePartner: CreatePartnerModal,
    companyProfileRequestRemoval: RequestRemovalModal,
};

export { companyProfileModals };
